export const EDIT_INTERFACE_URL = 'edit';
export const VIEW_INTERFACE_URL = 'view';
export const ADD_INTERFACE_URL = 'add';
